var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "level" },
        [
          _c(
            "Header",
            _vm._b(
              { staticClass: "level-left" },
              "Header",
              _vm.$route.meta,
              false
            )
          ),
          _c(
            "b-button",
            {
              staticClass: "left-right",
              attrs: {
                tag: "router-link",
                to: {
                  name: "closure-schedule",
                  params: { collect_group: this.$route.params.collect_group },
                },
                type: "is-info",
                "icon-left": "arrow-left",
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("global.back")) + " ")]
          ),
          _c(
            "b-button",
            {
              staticClass: "left-right",
              attrs: {
                tag: "router-link",
                to: {
                  name: "closure-templates-form",
                  params: {
                    template_id: "new",
                    collect_group: this.$route.params.collect_group,
                  },
                },
                type: "is-success",
                "icon-left": "plus",
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("pages.closure_schedule.mail_templates.new_button")
                  ) +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c("ag-grid-vue", {
              staticClass: "ag-theme-balham",
              staticStyle: { width: "100%", height: "700px" },
              attrs: {
                "row-data": _vm.enduserMailTemplates,
                "grid-options": _vm.gridOptions,
                pagination: true,
                "pagination-auto-page-size": true,
                "side-bar": ["columns"],
                "cache-overflow-size": 0,
                "multi-sort-key": "ctrl",
                modules: _vm.modules,
                "get-context-menu-items": _vm.getContextMenuItems,
              },
              on: { "grid-ready": _vm.gridReady },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }